export default __webpack_public_path__ + "static/media/analytics.9a42b4de.svg";